/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripAutoAssignmentProcessStatus = {
    Queued: 'Queued',
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed',
    Cancelled: 'Cancelled'
} as const;
export type TaxiTripAutoAssignmentProcessStatus = typeof TaxiTripAutoAssignmentProcessStatus[keyof typeof TaxiTripAutoAssignmentProcessStatus];

